import { makeStyles } from '@fluentui/react';
export const useStyles = makeStyles((theme) => ({
  link: {
    color: theme.palette.themeDark,
    ':focus': {
      color: theme.palette.themeDark,
    },
  },
  linkBold: {
    fontWeight: 'bold',
    color: theme.palette.themePrimary,
    ':focus': {
      color: theme.palette.themePrimary,
    },
  },
}));
